<template>
  <tr class="operative-table-section-title">
    <th :colspan="numColumns" :class="{ 'text-left': align === 'left', 'text-center': align === 'center', 'text-right': align === 'right' }">
      <slot></slot>
    </th>
  </tr>
</template>

<script>

export default {
  name: 'kpi-section-title',
  props: {
    years: {
      type: Array,
      default: () => [],
    },
    align: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    numColumns () {
      return (this.years?.length || 0) + 1;
    },
  },
};

</script>

<style lang="scss">

.operative-table-section-title {
  th {
    text-align: center;
    font-weight: normal;
    font-size: 1.25rem;
    color: #6c757d;
    border-top: none;
  }
}

</style>
